<template>
  <div class="m-0 dbozone-font bg-mahjongXmas" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-mahjongXmas">
        <section class="d-flex p-2 justify-content-center align-items-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -mahjongXmas`">{{ $t('mahjongXmas.name') }}
          </h5>
        </section>
      </div>

      <div>
        <h3 class="m-0 text-bold pt-5 pb-3">{{ $t('mahjongXmas.gamerule') }}</h3>
      </div>
      <div class="d-flex p-2 mt-1" v-for="(text, index) in textList" :key="'textList' + index">
        <div v-if="index === 0">
          <div>
            <span class="m-0 text-sub-title-mahjongXmas" :class="`-${lang}`">{{ $t('mahjongXmas.name') }} :</span>
            <span class="m-0 text-sub"> {{ $t(text) }}</span>
          </div>
        </div>
        <div v-else>
          <span v-if="index === 1" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}
            {{ currencyFormatterWithSymbol(betMinMax[0]) }}</span>
          <span v-else-if="index === 2" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}
            {{ currencyFormatterWithSymbol(betMinMax[1]) }}</span>
          <span v-else-if="index === 3" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) + baseBet +
            $t('mahjongXmas.text-rule5') }} </span>
          <span v-else-if="index === 4" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) +
            currencyFormatterWithSymbol(betSize[0])
            + $t('info.to') + currencyFormatterWithSymbol(betSize[betSize.length - 1]) + $t('mahjongXmas.text-rule7')
            + betLevel[0] + $t('info.to') + betLevel[betLevel.length - 1] + $t('mahjongXmas.text-rule8') }} </span>
          <span v-else-if="index === 5" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) + currency + `(` +
            formattedCurrency + `)` }}</span>
          <span v-else-if="index === 10" class="m-0 text-sub-title-mahjongXmas" :class="`-${lang}`">
            <div class="pt-4">
              {{ $t(text) }}
            </div>
          </span>
          <span v-else-if="index > 5" class="m-0 text-sub p-4" :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>

      <div class="pt-5"></div>

      <div class="d-flex flex-column nav-mahjongXmas">
        <section class="d-flex p-2 justify-content-center align-items-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -mahjongXmas`">{{ $t('mahjongXmas.round') }}
          </h5>
        </section>
      </div>

      <div class="d-flex p-2 mt-1 pb-3" v-for="(text, index) in roundList" :key="'roundList' + index">
        <div>
          <span v-if="index === 0" class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          <span v-if="index === 1" class="m-0 text-bold" :class="`-${lang}`">{{ $t('mahjongXmas.round-title1')
          }}</span>
          <span v-if="index === 1" class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          <span v-if="index === 2" class="m-0 text-bold-mahjongXmas" :class="`-${lang}`">{{
            $t('mahjongXmas.round-title2')
            }}</span>
          <span v-if="index === 2" class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          <span v-if="index === 3" class="m-0 text-bold-mahjongXmas" :class="`-${lang}`">{{
            $t('mahjongXmas.round-title3')
            }}</span>
          <span v-if="index === 3" class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          <span v-if="index === 4" class="m-0 text-bold-mahjongXmas" :class="`-${lang}`">{{
            $t('mahjongXmas.round-title4')
            }}</span>
          <span v-if="index === 4" class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          <div v-if="index === 5" class="m-0 text-bold-mahjongXmas" :class="`-${lang}`">{{
            $t('mahjongXmas.round-title5')
            }}</div>
          <span v-if="index === 5" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}</span>
          <span v-if="index === 6" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}</span>
          <span v-if="index === 7" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}</span>
          <span v-if="index === 8" class="m-0 text-bold-mahjongXmas" :class="`-${lang}`">{{
            $t('mahjongXmas.round-title6')
            }}</span>
          <span v-if="index === 8" class="m-0 text-sub " :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>

      <div class="pt-5"></div>

      <div class="d-flex flex-column nav-mahjongXmas">
        <section class="d-flex p-2 justify-content-center align-items-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -mahjongXmas`">{{ $t('mahjongXmas.payout-rules')
            }}
          </h5>
        </section>
      </div>

      <div class="pt-4">
        <span class="m-0 text-bold-mahjongXmas">{{ $t('mahjongXmas.ways-to-win') }}</span>
        <div class="m-0 text-sub ">{{ $t('mahjongXmas.ways-to-win1') }}</div>
      </div>

      <div class="pt-4">
        <span class="m-0 text-bold-mahjongXmas ">{{ $t('mahjongXmas.payouts') }}</span>
        <div class="m-0 text-sub ">{{ $t('mahjongXmas.payouts1') }}</div>
      </div>

      <div class="pt-4">
        <span class="m-0 text-bold-mahjongXmas ">{{ $t('mahjongXmas.goldframe-symbols') }}</span>
        <div class="m-0 text-sub ">{{ $t('mahjongXmas.goldframe-symbols1') }}</div>
      </div>

      <div class="pt-4">
        <span class="m-0 text-bold-mahjongXmas ">{{ $t('mahjongXmas.cascading-wins') }}</span>
        <div class="m-0 text-sub ">{{ $t('mahjongXmas.cascading-wins1') }}</div>
      </div>

      <div class="pt-4">
        <span class="m-0 text-bold-mahjongXmas ">{{ $t('mahjongXmas.multiplier-for-regular-game') }}</span>
        <div class="m-0 text-sub">{{ $t('mahjongXmas.multiplier-for-regular-game1') }}</div>
        <div v-for="index in 4" class="m-0 text-sub pt-4" :key="'regular-game' + index">
          {{ $t(`mahjongXmas.multiplier-for-regular-game${index + 1}`) }}</div>
      </div>

      <div class="pt-4">
        <span class="m-0 text-bold-mahjongXmas ">{{ $t('mahjongXmas.multiplier-for-freespin-game') }}</span>
        <div class="m-0 text-sub">{{ $t('mahjongXmas.multiplier-for-freespin-game1') }}</div>
        <div v-for="index in 5" class="m-0 text-sub pt-4" :key="'freespin-game' + index">
          {{ $t(`mahjongXmas.multiplier-for-freespin-game${index + 1}`) }}</div>
      </div>

      <div class="pt-4">
        <span class="m-0 text-bold-mahjongXmas ">{{ $t('mahjongXmas.total-payouts') }}</span>
        <div class="m-0 text-sub ">{{ $t('mahjongXmas.total-payouts1') }}</div>
      </div>

      <div class="d-flex p-2 mt-1 mb-2 justify-content-center">
        <img class="mt-3 icon-way" :src="require(`../../assets/ruleGames/mahjongXmas/rule_bet.png`)" alt="">
      </div>
      <div class="pt-4">
        <span class="m-0 text-sub ">
          {{ '(' }}
          {{ $t('main-game.betSize') }} {{ 0.001 }} X
          {{ $t('main-game.betLevel') }} {{ 1 }} X
          {{ $t('main-game.baseBet') }} {{ baseBet }} =
          {{ $t('main-game.betAmount') }} {{ currencyFormatterWithSymbol(0.001 * 1 * baseBet) }}
          {{ ')' }}
        </span>
      </div>

      <div v-for="index in 5" class="pt-4" :key="index">
        <span class="m-0 text-bold-mahjongXmas">{{ $t(`mahjongXmas.payout-cal-title${index}`) }}</span>

        <div v-if="index === 2" class="m-0 text-sub ">{{ $t(`mahjongXmas.payout-cal${index}`) }}
          {{ currencyFormatterWithSymbol(0.02 * paytable[7][2] / baseBet) }} X 3 {{ $t('main-game.ways') }}
          = {{ currencyFormatterWithSymbol((0.02 * paytable[7][2] / baseBet) * 3) }}
        </div>
        <div v-else-if="index === 3" class="m-0 text-sub ">{{ $t(`mahjongXmas.payout-cal${index}`) }}
          {{ currencyFormatterWithSymbol(0.02 * paytable[3][2] / baseBet) }}
          {{ $t(`mahjongXmas.payout-cal${index}-1`) }}</div>
        <div v-else-if="index === 4" class="m-0 text-sub ">
          {{ $t(`mahjongXmas.payout-cal${index}`) }}
          {{ '(' + currencyFormatterWithSymbol(0.02 * paytable[7][2] / baseBet) }} {{ ' X 3) + ' }}
          {{ '(' + currencyFormatterWithSymbol(0.02 * paytable[3][2] / baseBet) }} {{ ' X 1)' }}
          = {{ currencyFormatterWithSymbol(((0.02 * paytable[7][2] / baseBet) * 3) + (0.02 * paytable[3][2]
            / baseBet)) }}
        </div>
        <div v-else-if="index === 5" class="m-0 text-sub ">{{ $t(`mahjongXmas.payout-cal${index}`) }}
          {{ currencyFormatterWithSymbol(((0.02 * paytable[7][2] / baseBet) * 3) + (0.02 * paytable[3][2] /
            baseBet)) }}
          {{ $t(`mahjongXmas.payout-cal${index}-1`) }}
        </div>
        <div v-else class="m-0 text-sub ">{{ $t(`mahjongXmas.payout-cal${index}`) }}</div>
      </div>

      <div class="pt-5"></div>

      <div class="d-flex flex-column nav-mahjongXmas">
        <section class="d-flex p-2 justify-content-center align-items-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -mahjongXmas`">{{ $t('mahjongXmas.paytable') }}
          </h5>
        </section>
      </div>

      <div class="pt-4">
        <span class="m-0 text-sub">{{ $t('mahjongXmas.paytable-des') }}</span>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/mahjongXmas/symbol_7.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class="sub-text-payout-mahjongXmas" :class="`-${lang}`">
            {{ '5 - ' + decimalFormat(currentBet * paytable[7][4] / baseBet) }}<br>
            {{ '4 - ' + decimalFormat(currentBet * paytable[7][3] / baseBet) }}<br>
            {{ '3 - ' + decimalFormat(currentBet * paytable[7][2] / baseBet) }}
          </span>
        </div>

        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/mahjongXmas/symbol_6.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class="sub-text-payout-mahjongXmas" :class="`-${lang}`">
            {{ '5 - ' + decimalFormat(currentBet * paytable[6][4] / baseBet) }}<br>
            {{ '4 - ' + decimalFormat(currentBet * paytable[6][3] / baseBet) }}<br>
            {{ '3 - ' + decimalFormat(currentBet * paytable[6][2] / baseBet) }}
          </span>
        </div>
      </div>

      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable-payout" :src="require(`../../assets/resultGame/mahjongXmas/symbol_5.png`)"
            alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class="sub-text-payout-mahjongXmas" :class="`-${lang}`">
            {{ '5 - ' + decimalFormat(currentBet * paytable[5][4] / baseBet) }}<br>
            {{ '4 - ' + decimalFormat(currentBet * paytable[5][3] / baseBet) }}<br>
            {{ '3 - ' + decimalFormat(currentBet * paytable[5][2] / baseBet) }}
          </span>
        </div>

        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable-payout" :src="require(`../../assets/resultGame/mahjongXmas/symbol_4.png`)"
            alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class="sub-text-payout-mahjongXmas" :class="`-${lang}`">
            {{ '5 - ' + decimalFormat(currentBet * paytable[4][4] / baseBet) }}<br>
            {{ '4 - ' + decimalFormat(currentBet * paytable[4][3] / baseBet) }}<br>
            {{ '3 - ' + decimalFormat(currentBet * paytable[4][2] / baseBet) }}
          </span>
        </div>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/mahjongXmas/symbol_3.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class="sub-text-payout-mahjongXmas" :class="`-${lang}`">
            {{ '5 - ' + decimalFormat(currentBet * paytable[3][4] / baseBet) }}<br>
            {{ '4 - ' + decimalFormat(currentBet * paytable[3][3] / baseBet) }}<br>
            {{ '3 - ' + decimalFormat(currentBet * paytable[3][2] / baseBet) }}
          </span>
        </div>

        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/mahjongXmas/symbol_2.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class="sub-text-payout-mahjongXmas" :class="`-${lang}`">
            {{ '5 - ' + decimalFormat(currentBet * paytable[2][4] / baseBet) }}<br>
            {{ '4 - ' + decimalFormat(currentBet * paytable[2][3] / baseBet) }}<br>
            {{ '3 - ' + decimalFormat(currentBet * paytable[2][2] / baseBet) }}
          </span>
        </div>
      </div>

      <div class="col-12 mt-3 justify-content-left d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/mahjongXmas/symbol_1.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class="sub-text-payout-mahjongXmas" :class="`-${lang}`">
            {{ '5 - ' + decimalFormat(currentBet * paytable[1][4] / baseBet) }}<br>
            {{ '4 - ' + decimalFormat(currentBet * paytable[1][3] / baseBet) }}<br>
            {{ '3 - ' + decimalFormat(currentBet * paytable[1][2] / baseBet) }}
          </span>
        </div>

        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/mahjongXmas/symbol_0.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class="sub-text-payout-mahjongXmas" :class="`-${lang}`">
            {{ '5 - ' + decimalFormat(currentBet * paytable[0][4] / baseBet) }}
            <br>{{ '4 - ' + decimalFormat(currentBet * paytable[0][3] / baseBet) }}
            <br>{{ '3 - ' + decimalFormat(currentBet * paytable[0][2] / baseBet) }}
          </span>
        </div>
      </div>

      <div class="pt-2">
        <h3 class="m-0 text-title-bold-mahjongXmas pt-5 pb-3">{{ $t('mahjongXmas.adjustment') }}</h3>
      </div>

      <div class="pt-4">
        <span class="m-0 text-sub ">{{ $t('mahjongXmas.adjustment-des') }}</span>
      </div>

      <div class="pt-4">
        <span class="m-0 text-bold-mahjongXmas ">{{ $t('mahjongXmas.note') }}</span>
        <div class="m-0 text-sub ">{{ $t('mahjongXmas.note-des1') }}</div>
        <div class="m-0 text-sub ">{{ $t('mahjongXmas.note-des2') }}</div>
      </div>

      <div class="pt-5"></div>

      <div class="d-flex flex-column nav-mahjongXmas">
        <section class="d-flex p-2 justify-content-center align-items-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -mahjongXmas`">{{ $t('mahjongXmas.goldframe') }}
          </h5>
        </section>
      </div>

      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-symbol" :src="require(`../../assets/paytable/mahjongXmas/way.png`)" alt="">
      </div>

      <div class="d-flex p-2 mt-1" v-for="(text, index) in goldframeList" :key="'goldframeList' + index">
        <div>
          <span class="m-0 text-sub " :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>

      <div class="pt-5"></div>

      <div class="d-flex flex-column nav-mahjongXmas">
        <section class="d-flex p-2 justify-content-center align-items-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -mahjongXmas`">{{ $t('mahjongXmas.wildsymbol')
            }}
          </h5>
        </section>
      </div>

      <div class="d-flex p-2 mt-1" v-for="(text, index) in wildList" :key="'wildList' + index">
        <div>
          <span v-if="index === 0" class="m-0 text-sub " :class="`-${lang}`">{{ $t(text) }}
            <div class="d-flex p-2 mt-1 justify-content-center">
              <img class="mt-3 icon-symbol" :src="require(`../../assets/resultGame/mahjongXmas/symbol_9.png`)" alt="">
            </div>
          </span>
          <span v-else-if="index === 3">
            <span class="m-0 text-bold " :class="`-${lang}`">{{ $t('mahjongXmas.wild-example') }}</span>
            <span class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          </span>
          <span v-else-if="index === 4">
            <span class="m-0 text-bold " :class="`-${lang}`">{{ $t('mahjongXmas.wild-note') }}</span>
            <span class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          </span>
          <span v-else class="m-0 text-sub " :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>

      <div class="pt-5"></div>

      <div class="d-flex flex-column nav-mahjongXmas">
        <section class="d-flex p-2 justify-content-center align-items-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -mahjongXmas`">{{ $t('mahjongXmas.multipliers')
            }}
          </h5>
        </section>
      </div>

      <div class="d-flex mt-1 justify-content-center">
        <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/mahjongXmas/multiplier.png`)" alt="">
      </div>

      <div class="m-0 text-bold-mahjongXmas pl-2 pt-4">{{ $t(`mahjongXmas.multipliers-normal`) }}</div>

      <div class="d-flex p-2 mt-1" v-for="index in 5" :key="'multipliers-normal' + index">
        <div>
          <span class="m-0 text-sub " :class="`-${lang}`">{{ $t(`mahjongXmas.multipliers-normal${index}`) }}</span>
        </div>
      </div>

      <div class="m-0 text-bold-mahjongXmas pl-2 pt-4">{{ $t(`mahjongXmas.multipliers-free`) }}</div>

      <div class="d-flex p-2 mt-1" v-for="index in 5" :key="'multipliers-free' + index">
        <div>
          <span class="m-0 text-sub " :class="`-${lang}`">{{ $t(`mahjongXmas.multipliers-free${index}`) }}</span>
        </div>
      </div>

      <div class="pt-5"></div>

      <div class="d-flex flex-column nav-mahjongXmas">
        <section class="d-flex p-2 justify-content-center align-items-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -mahjongXmas`">{{ $t('mahjongXmas.freespin') }}
          </h5>
        </section>
      </div>

      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-symbol" :src="require(`../../assets/resultGame/mahjongXmas/symbol_8.png`)" alt="">
        <img class="mt-3 icon-symbol" :src="require(`../../assets/resultGame/mahjongXmas/symbol_8.png`)" alt="">
        <img class="mt-3 icon-symbol" :src="require(`../../assets/resultGame/mahjongXmas/symbol_8.png`)" alt="">
      </div>

      <div class="d-flex p-2 mt-1" v-for="index in 17" :key="'freespin' + index">
        <div>
          <span v-if="index === 1 || index === 7 || index === 12" class="m-0 text-sub-title-mahjongXmas "
            :class="`-${lang}`">
            <div v-if="index === 7" class="d-flex p-2 mt-1 justify-content-center">
              <img class="mt-3" :src="require(`../../assets/ruleGames/mahjongXmas/feature.png`)" alt=""
                style="width:70%;">
            </div>
            {{ $t(`mahjongXmas.freespin-des${index}`) }}
          </span>
          <span v-else-if="index === 6">
            <span class="m-0 text-sub-title-mahjongXmas ">
              {{ $t(`mahjongXmas.mystery`) }} :
            </span>
            <span class="m-0 text-sub " :class="`-${lang}`">
              {{ $t(`mahjongXmas.freespin-des${index}`) }}
            </span>
          </span>
          <span v-else-if="index > 2 && index < 7">
            <span class="m-0 text-sub-title-mahjongXmas ">
              {{ $t(`mahjongXmas.mode`) }} :
            </span>
            <span class="m-0 text-sub " :class="`-${lang}`">
              {{ $t(`mahjongXmas.freespin-des${index}`) }}
            </span>
          </span>
          <span v-else class="m-0 text-sub " :class="`-${lang}`">{{ $t(`mahjongXmas.freespin-des${index}`) }}</span>
        </div>
      </div>

      <!-- <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3" :src="require(`../../assets/ruleGames/mahjongXmas/freespin.png`)" alt="" style="width:70%;">
      </div>

      <div class="d-flex p-2 mt-1" v-for="index in 7" :key="index">
        <div>
          <span v-if="index === 1" class="m-0 text-sub-title-mahjongXmas " :class="`-${lang}`">
            {{ $t(`mahjongXmas.freespin-multiplier${index}`) }}
          </span>
          <span v-else class="m-0 text-sub pt-4" :class="`-${lang}`">{{ $t(`mahjongXmas.freespin-multiplier${index}`)
          }}</span>
        </div>
      </div> -->

      <div class="pt-5"></div>

      <div class="d-flex flex-column nav-mahjongXmas">
        <section class="d-flex p-2 justify-content-center align-items-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -mahjongXmas`">{{ $t('mahjongXmas.buyfreespin')
            }}
          </h5>
        </section>
      </div>

      <div class="d-flex p-2 mt-1 mb-2 justify-content-center">
        <img class="mt-3 featurebuy" :src="require(`../../assets/paytable/mjl/feature_buy_${imgLang}.png`)" alt="">
      </div>

      <div class="d-flex p-2 mt-1" v-for="(text, index) in buyfreespinList" :key="'buyfreespinList' + index">
        <div>
          <span v-if="index === 0">
            <span class="m-0 text-sub " :class="`-${lang}`">{{ $t(text) }}</span>
          </span>
          <span v-else-if="index === 4" class="m-0 text-sub " :class="`-${lang}`">{{ $t(text)
            + currencyFormatterWithSymbol(betSize[0] * betLevel[0] * 20)
            + $t('mjl.buyfreespin-des6') + currencyFormatterWithSymbol(featureBuyMaximum)
          }}</span>
          <span v-else-if="index === 5" class="m-0 text-sub " :class="`-${lang}`">{{ $t(text)
            + currencyFormatterWithSymbol(featureBuyMaximum) +
            $t('mjl.buyfreespin-des8')
          }}</span>
          <span v-else class="m-0 text-sub " :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>

      <div class="pt-5"></div>

      <div class="d-flex flex-column nav-mahjongXmas">
        <section class="d-flex p-2 justify-content-center align-items-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -mahjongXmas`">{{ $t('mahjongXmas.way') }}
          </h5>
        </section>
      </div>

      <div class="d-flex p-2 mt-1" v-for="(text, index) in wayList" :key="'wayList' + index">
        <div>
          <span v-if="index === 1">
            <div class="d-flex p-2 mt-1 mb-2 justify-content-center">
              <img class="mt-3 icon-way" :src="require(`../../assets/paytable/mahjongXmas/line_paytable.png`)" alt="">
            </div>
            <span class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          </span>
          <span v-else class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>

      <div class="pt-5"></div>

      <div class="d-flex flex-column nav-mahjongXmas">
        <section class="d-flex p-2 justify-content-center align-items-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -mahjongXmas`">{{ $t('main-game.title') }}
          </h5>
        </section>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-spin" :src="require(`../../assets/ruleGames/mahjongXmas/spin_btn.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.spin') }}</span>
          <div v-for="(text, index) in spinList" :key="'spinList' + index">
            <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}</div>
          </div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/mahjongXmas/stop_btn.png`)" alt="">
        <div class="m-0 pl-3">
          <div class="m-0 text-sub pl-4\" :class="`-${lang}`">{{ $t('main-game.autospin-rounds-desc1') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/mahjongXmas/minus_btn.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.minus') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-minus') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/mahjongXmas/plus_btn.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.plus') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-plus') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/mahjongXmas/autospin_btn.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.autospin') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-auto1') }}</div>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-auto2') }}</div>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-auto4') }}</div>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-auto5') }}</div>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-auto6') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/mahjongXmas/menu_btn.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.additional') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.additional-des') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/main/wallet_icon.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.wallet') }}</span>
          <span class="m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.wallet-des1') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.wallet-des2') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/main/refresh_icon.png`)" alt="">
        <div class="m-0 pl-3 ">
          <span class="m-0 text-bold">{{ $t('main-game.refresh') }}</span>
          <span class="m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.refresh-des') }}</span>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/main/betamount_icon.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.bet-amount') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.bet-amount-des1') }}</div>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.bet-amount-des2') }}</div>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.bet-amount-des3') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/main/win_icon.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.winning') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.winning-des1') }}</div>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.winning-des2') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 pl--5 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/main/quit_icon.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.quit') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-quit') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/main/info_icon.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.pay-info') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-info') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/main/history_icon.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.history') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-history') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/main/option_icon.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.sound-settings') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.sound-settings-desc1') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-close" :src="require(`../../assets/ruleGames/main/close_icon.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.close') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-close') }}</div>
        </div>
      </div>

      <div class="p-5"></div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'rule-mahjongXmas',
  props: {
    data: Object,
    lang: String,
    imgLang: String,
    betMinMax: Array,
    currentBet: Number,
    currency: String,
    featureBuyMaximum: Number,
    isShowCurrencySymbol: Boolean,
  },
  data() {
    return {
      textList: [
        'mahjongXmas.text-rule1',
        'mahjongXmas.text-rule2',
        'mahjongXmas.text-rule3',
        'mahjongXmas.text-rule4',
        'mahjongXmas.text-rule6',
        'mahjongXmas.text-rule9',
        'mahjongXmas.text-rule10',
        'mahjongXmas.text-rule11',
        'mahjongXmas.text-rule12',
        'mahjongXmas.text-rule13',
        'mahjongXmas.text-rule14',
        'mahjongXmas.text-rule15',
        'mahjongXmas.text-rule16',
        'mahjongXmas.text-rule17',
        'mahjongXmas.text-rule18',
      ],
      roundList: [
        'mahjongXmas.round-des',
        'mahjongXmas.round-des1',
        'mahjongXmas.round-des2',
        'mahjongXmas.round-des3',
        'mahjongXmas.round-des4',
        'mahjongXmas.round-des5',
        'mahjongXmas.round-des6',
        'mahjongXmas.round-des7',
        'mahjongXmas.round-des8',

      ],
      goldframeList: [
        'mahjongXmas.goldframe-desc1',
        'mahjongXmas.goldframe-desc2',
        'mahjongXmas.goldframe-desc3',
        'mahjongXmas.goldframe-desc4',
        'mahjongXmas.goldframe-desc5',
      ],
      wildList: [
        'mahjongXmas.wildsymbol-desc1',
        'mahjongXmas.wildsymbol-desc2',
        'mahjongXmas.wildsymbol-desc3',
        'mahjongXmas.wildsymbol-desc4',
        'mahjongXmas.wildsymbol-desc5',
      ],
      buyfreespinList: [
        'mahjongXmas.buyfreespin-des1',
        'mahjongXmas.buyfreespin-des2',
        'mahjongXmas.buyfreespin-des3',
        'mahjongXmas.buyfreespin-des4',
        'mahjongXmas.buyfreespin-des5',
        'mahjongXmas.buyfreespin-des7',
        'mahjongXmas.buyfreespin-des9',
      ],
      wayList: [
        'mahjongXmas.way-des1',
        'mahjongXmas.way-des2',
      ],
      spinList: [
        'main-game.spin-des1',
        'main-game.spin-des2',
        'main-game.spin-des3',
        'main-game.spin-des4',
        'main-game.spin-des5',
      ],

      baseBet: this.data.config.baseBet,
      betLevel: this.data.config.betLevel,
      betSize: this.data.config.betSize,
      paytable: this.data.config.payTable,
    }
  },
  computed: {
    formattedCurrency() {
      return this.$options.filters.currencySymbol(this.currency);
    },
  },
  methods: {
    currencyFormatterWithSymbol(val) {
      if (this.isShowCurrencySymbol === false) {
        this.currency = '';
      }
      return this.$options.filters.currencyFormatterWithSymbol(val, this.currency);
    },
    decimalFormat(val) {
      return this.$options.filters.decimalFormat(val);
    }
  }
}
</script>

<style>
.bg-mahjongXmas {
  background: #113E26;
}

.nav-mahjongXmas {
  background: #A61E2C;
  /* border-radius: 50px; */
}

.text-title.-mahjongXmas {
  color: #fff;
}

.text-title-bold-mahjongXmas {
  color: #A61E2C;
  text-align: center;
  font-size: 5vw;
  font-weight: bold;
}

.text-bold-mahjongXmas {
  color: #A61E2C;
  text-align: left;
  font-size: 4vw;
  font-weight: bold;
}

.icon-info {
  width: 100px;
  height: 100px;
  margin-right: 10px;
}

.icon-spin {
  width: 30%;
  height: 30%;
  margin-right: 10px;
}

.icon-menu {
  width: 15%;
  height: 15%;
  margin-right: 10px;
}

.icon-close {
  width: 12%;
  height: 12%;
  margin-right: 10px;
}

.icon-refresh {
  width: 120px;
  height: 120px;
  padding-left: -20px;
}

.icon-way {
  width: 90%;
  height: 90%;
}

.featurebuy {
  width: 70%;
  height: 70%;
}

.icon-symbol {
  width: 25vw
}

.sub-text-payout-mahjongXmas {
  font-size: 3.5vw;
  color: white;
}

.text-sub-title-mahjongXmas {
  color: #A61E2C;
  font-size: 4vw;
  text-align: left;
}

@media (min-width: 576px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 720px;
  }
}

@media (min-width: 768px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 920px;
  }
}

@media (min-width: 1024px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 1520px;
  }
}
</style>